import { FileUpload } from "primereact/fileupload";
import React, { useRef, useState } from "react";
import {
    createAPIEndpntBeatfreq,
    Endpoint,
} from "../../Services/BeatFrequencyPlanning/beatfreqplanngservice";
import storage from "../../Services/Storage";
import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";
import * as Fa from "react-icons/fa";
// import * as XLSX from "xlsx";
// import { read, utils } from "xlsx";
// import { ExtractExcelFileData } from "../../Services/GlobalFunc/excelDataExtract";
import { ExtractExcelFileData } from "../../Services/GlobalFunc/ExtractExcelFileData";
import { toast } from "react-toastify";
// import { ProgressSpinner } from "primereact/progressspinner";
import Loader from "../../Components/Loader";
import axios from "axios";

const BeatFrequencyPlanning = () => {
    const auth = storage.getLocal("user");
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [errorxlsbtn, setErrorxlsbtn] = useState(false);
    const [uploadloader, setUploadloader] = useState(false);
    const [errorexceldata, setErrorexceldata] = useState([]);

    const fileUploadRef = useRef(null);
    const downloadtemp = async () => {
        // debugger;
        setLoadingExcel(true);
        await createAPIEndpntBeatfreq()
            .get(`${Endpoint.DownloadTemplate}?UserId=${auth.UserId}`)
            .then(async (val) => {
                if (val.data.Status == "Warning") {
                    toast.warning(`${val.data.Message}`, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 4000,
                    });
                } else {
                    const url = val.data.fileURl; 
                    const fileName = `DB_Beatplanning${GetDateFormat()}.xlsx`;
                    const fileResponse = await axios.get(url, { responseType: "blob" });
                    const blob = new Blob([fileResponse.data], { type: fileResponse.headers["content-type"] });
                    // Create a download link
                    const blobUrl = window.URL.createObjectURL(blob);    
                    const a = document.createElement("a"); // Create an anchor element
                    a.href = blobUrl;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoadingExcel(false);
            });
    };

    const handleFileUpload = async (event) => {
    // let parsedData = [];
    // debugger;
        setUploadloader(true);
        let fileTypes = [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        const selectedFile = event.files[0];
        let actualheader = [
            "Comp Code",
            "Company Name",
            "Stream",
            "Channel",
            "Sub Channel",
            "Segment",
            "Customer Creation Date",
            "Party Code",
            "Party Name",
            "Customer Unique Code",
            "Party Town Name",
            "Volume Avg",
            "Classification",
            "Beat Frequency Code",
            "Beat Coverage Type",
            "SE Code",
            "SE Name",
            "Starting Week",
            "Beat Day 1",
            "Beat Day 2",
            "Delivery Frequency Code",
            "Delivery Coverage Type",
            "Delivery Day 1",
            "Delivery Day 2",
        ];
        let filedata = await ExtractExcelFileData(selectedFile);
        let validFileCheck =
      JSON.stringify(actualheader) === JSON.stringify(filedata.headers);
        console.log(filedata);
        // console.log(actualheader);
        // console.log(filedata.headers);
        // console.log(validFileCheck);

        if (selectedFile && fileTypes.includes(selectedFile.type)) {
            if (!validFileCheck) {
                toast.warning("Please specify a valid file content", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 4000,
                });
                setUploadloader(false);
                return;
            } else {
                const keys = [
                    "comP_CODE",
                    "companY_NAME",
                    "stream",
                    "channel",
                    "suB_CHANNEL",
                    "segment",
                    "customeR_CREATION_DATE",
                    "partY_CODE",
                    "partY_NAME",
                    "customeR_UNIQUE_CODE",
                    "partY_TOWN_NAME",
                    "volumE_AVG",
                    "classification",
                    "beaT_FREQUENCY_CODE",
                    "beaT_COVERAGE_TYPE",
                    "sE_CODE",
                    "sE_NAME",
                    "startinG_WEEK",
                    "beaT_DAY_1",
                    "beaT_DAY_2",
                    "deliverY_FREQUENCY_CODE",
                    "deliverY_COVERAGE_TYPE",
                    "deliverY_DAY_1",
                    "deliverY_DAY_2",
                ];

                const result = filedata.data.map((row) => {
                    const obj = {};
                    row.forEach((value, index) => {
                        obj[keys[index]] = value; // Assign the value or null if the value is an empty string
                    });
                    return obj;
                });
                let payload = {
                    userId: auth.UserId,
                    compId: auth.CompId,
                    excelsData: result,
                };

                // console.log(payload);
                
                createAPIEndpntBeatfreq()
                    .post(`${Endpoint.UploadExcel}`, JSON.stringify(payload), {
                        headers: { "Content-Type": "application/json" },
                    })
                    .then((res) => {
                        if (res.data.Status == "Success") {
                            toast.success("Data Uploaded Successfully", {
                                position: toast.POSITION.TOP_CENTER,
                                pauseOnFocusLoss: false,
                                closeButton: false,
                                autoClose: 3000,
                            });
                            setErrorxlsbtn(false);
                            fileUploadRef.current.clear();
                            setUploadloader(false);
                        } else if (res.data.Status === "Warning") {
                            toast.warning(res.data.Message, {
                                position: toast.POSITION.TOP_CENTER,
                                pauseOnFocusLoss: false,
                                closeButton: false,
                                autoClose: 3000,
                            });
                            setErrorexceldata(res.data.Data);
                            setErrorxlsbtn(true);
                            setUploadloader(false);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        toast.error(`${error.response?.data?.Message}`, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 3000,
                        });
                        setUploadloader(false);
                    });
                setUploadloader(false);
            }
        } else {
            toast.warning("Please specify a valid file. Can upload only Excel file", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 4000,
            });
            setUploadloader(false);
        }
    };
    const handleExportErrorxls = () => {
        downloadExcel(errorexceldata, "DB_Beatplanning_error.xlsx");
    };
    if (uploadloader) {
        return (
            <>
                <Loader />
            </>
        );
    } else {
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Beat Frequency Planning</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary me-3"
                                    onClick={downloadtemp}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Download Planning Sheet"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                                {errorxlsbtn && (
                                    <button
                                        type="submit"
                                        className="btn btn-cancel-red"
                                        onClick={handleExportErrorxls}
                                    >
                    Export Error File <Fa.FaFileExport className="ms-2" />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    <section className="sales-box">
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-8 col-md-6 col-sm-12">
                                <div className="UploadSection">
                                    <FileUpload
                                        ref={fileUploadRef}
                                        customUpload
                                        className="clearfix nTopMargin"
                                        uploadHandler={handleFileUpload}
                                        single="true"
                                        accept=".xlsx, .xls, .csv"
                                        onClear={() => {
                                            setErrorxlsbtn(false);
                                        }}
                                        onRemove={() => {
                                            setErrorxlsbtn(false);
                                        }}
                                        emptyTemplate={
                                            <p className="m-0">Drag and drop files here to upload.</p>
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="text-end">
                                    <img
                                        src={require("../../Assets/Images/File_Upload.png")}
                                        className="File_Upload_Img"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
};

export default BeatFrequencyPlanning;
